import packageVersion from './package-version.json';

/** SemVer — synced with package.json / VERSION via scripts/bump-version.mjs */
export const APP_VERSION = packageVersion.version;

/** ISO timestamp when the bundle was built (production/staging builds via craco DefinePlugin). */
export const APP_BUILD_TIME = process.env.REACT_APP_BUILD_TIME || '';
